import { FC } from "react";
import { Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { InfoIcon } from "../../assets/icons";

interface Props {
	title: string;
	noPaddingTop?: boolean;
	infoTooltip?: string;
}

/**
 * FormSectionTitle renders a Grid element with fixed size 12 that contains a
 * text; this should be used to build forms whenever a section title is needed
 * at a certain "point" of a form.
 *
 * This component always sets pt = 2.
 *
 * @param noPaddingTop
 * @param title the section title
 * @returns     a component that renders a title to be used to group form components
 */
const FormSectionTitle: FC<Props> = ({ title, noPaddingTop, infoTooltip }) => {
	return (
		<Grid size={12}>
			<Stack spacing={1} direction="row" alignItems="center" pt={noPaddingTop ? undefined : 2} pb={1}>
				<Typography variant="h6" fontWeight="500">
					{title}
				</Typography>
				{infoTooltip && (
					<Tooltip title={infoTooltip}>
						<IconButton
							sx={{
								"&:hover": {
									backgroundColor: "transparent",
									boxShadow: "none",
									cursor: "default",
								},
							}}
						>
							<InfoIcon color="info" />
						</IconButton>
					</Tooltip>
				)}
			</Stack>
		</Grid>
	);
};

export default FormSectionTitle;
